/**
 * Child profiles for Study Buddy. Each profile has its own name, optional
 * subject list, study style, and grade level so the tutor can tailor behavior.
 */
export type StudyStyle = 'socratic' | 'direct' | 'balanced';

export interface Profile {
  id: string;
  name: string;
  /** e.g. "8th grade" – used in system prompt for age-appropriate responses */
  gradeLevel?: string;
  /** How the tutor guides: socratic = guide to answers, direct = explain clearly, balanced = mix */
  studyStyle: StudyStyle;
  /** If set, only these subject IDs show in the sidebar; otherwise all subjects */
  subjectIds?: string[];
}

export const PROFILES: Profile[] = [
  {
    id: 'profile-1',
    name: 'Harrison',
    gradeLevel: '8th grade',
    studyStyle: 'socratic',
    subjectIds: ['math', 'science', 'history', 'english', 'spanish'], // only these five subjects
  },
  {
    id: 'profile-2',
    name: 'Cam',
    gradeLevel: '5th grade',
    studyStyle: 'socratic',
    subjectIds: ['math', 'science', 'social-studies', 'english', 'french'], // only these five subjects
  },
];

const STORAGE_KEY = 'study-buddy-selected-profile';

export function getStoredProfileId(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function setStoredProfileId(profileId: string): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, profileId);
  } catch {
    // ignore
  }
}

export function clearStoredProfile(): void {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}

export function getProfileById(profileId: string): Profile | undefined {
  return PROFILES.find((p) => p.id === profileId);
}
